"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const IMAGE_BASE = "/image/new-version/fabrication/laser-cutting/materials";

const COLUMNS = [
	{ image: `${IMAGE_BASE}/1.png`, translationPrefix: "col1" as const },
	{ image: `${IMAGE_BASE}/2.png`, translationPrefix: "col2" as const },
	{ image: `${IMAGE_BASE}/3.png`, translationPrefix: "col3" as const },
];

export default function LaserCuttingMaterials() {
	const t = useTranslations("laserCuttingMaterialsSection");

	return (
		<section
			className="bg-[#f5f5f5] py-8 sm:py-10 md:py-12 lg:py-16"
			aria-labelledby="laser-cutting-materials-heading"
		>
			<div className="container px-3 sm:px-4 md:px-6">
				<header className="mb-6 sm:mb-8 md:mb-10 lg:mb-12 flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between lg:gap-10 xl:gap-16">
					<h2
						id="laser-cutting-materials-heading"
						className="max-w-xl text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl"
					>
						{t("sectionTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base lg:max-w-[50%] lg:shrink-0 lg:pt-1">
						{t("intro")}
					</p>
				</header>

				<div className="overflow-hidden rounded-xl border border-[#d0d0d0] bg-[#F3F3F3]">
					<div className="grid grid-cols-1 md:grid-cols-3">
						{COLUMNS.map((col, index) => (
							<div
								key={col.translationPrefix}
								className={`relative px-5 py-8 sm:px-7 sm:py-10 md:px-8 ${
									index > 0
										? "md:before:pointer-events-none md:before:absolute md:before:bottom-10 md:before:left-0 md:before:top-10 md:before:w-px md:before:bg-[#d0d0d0]"
										: ""
								}`}
							>
								<h3 className="mb-4 text-lg font-bold text-black sm:mb-5 sm:text-xl md:text-2xl">
									{t(`${col.translationPrefix}Title`)}
								</h3>
								<div className="relative mb-5 aspect-[23/14] w-full overflow-hidden bg-[#F3F3F3] sm:mb-6">
									<Image
										src={encodeURI(col.image)}
										alt={t(`${col.translationPrefix}Alt`)}
										fill
										className="object-cover"
										sizes="(max-width: 768px) 100vw, 33vw"
									/>
								</div>
								<p className="text-left text-sm leading-relaxed text-black md:text-base">
									{t(`${col.translationPrefix}Desc`)}
								</p>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
